export default "__VITE_ASSET__CC_C1pYA__"